/**
 * ─── Manifesto background bridge ──────────────────────────────────────────────
 *
 * Tiny module-level pub/sub carrying the hero manifesto ritual from React into the
 * Shimmering Prism engine, which lives OUTSIDE the component tree (so it can't be
 * reached via SketchContext — that is null in shimmer mode). Mirrors homeSection.js.
 *
 *   publishHold(progress)   number 0..1 each RAF frame during the 2s hold; null = released/aborted.
 *   publishManifesto(bool)  manifesto activated (hold completed) / deactivated.
 *
 * Consumers subscribe with { onHold?, onManifesto? }:
 *   - ShimmeringBackground (shimmer mode only) → engine freeze/shake (onHold) + explode/restore (onManifesto).
 *   - BackgroundAudioProvider (both modes) → ducks the background music volume on onManifesto.
 * In 'legacy' mode ShimmeringBackground isn't mounted, so publishHold has no engine listener (the legacy
 * Sketch is driven through SketchContext instead); publishManifesto still reaches the audio provider, so
 * music ducking works in both modes.
 * ──────────────────────────────────────────────────────────────────────────── */

const listeners = new Set();

export function publishHold(progress) {
    listeners.forEach((h) => { if (h.onHold) h.onHold(progress); });
}

export function publishManifesto(active) {
    listeners.forEach((h) => { if (h.onManifesto) h.onManifesto(active); });
}

/**
 * Subscribe the out-of-tree engine. `handlers` = { onHold(progressOrNull), onManifesto(bool) }.
 * Returns an unsubscribe function.
 */
export function subscribeManifestoBackground(handlers) {
    listeners.add(handlers);
    return () => { listeners.delete(handlers); };
}
